import React from 'react';
import { WrenchIcon } from 'lucide-react';
import './FeatureDisabled.css';

const FeatureDisabled = ({ feature = 'This feature', message = null }) => (
  <div className="feature-disabled">
    <div className="feature-disabled-icon">
      <WrenchIcon size={36} strokeWidth={1.5} />
    </div>
    <h3 className="feature-disabled-title">{feature} is Temporarily Unavailable</h3>
    <p className="feature-disabled-desc">
      {message || "We're making improvements. This will be back shortly. Thank you for your patience!"}
    </p>
    <p className="feature-disabled-contact">
      Need help? Contact us at <a href="mailto:sales@auroragh.com">sales@auroragh.com</a>
    </p>
  </div>
);

export default FeatureDisabled;